import ROUTES from "../../data/constants/routes";

import TempoRouterLink from "../../components/tempo-router-link/TempoRouterLink";
import BeginRegistrationForm from "../../features/register/BeginRegistrationForm";

import { Typography } from "@uhc-tempo/components";
const { H1, Link, Paragraph } = Typography;

export default function Register(props) {
  return (
    <section className="fluid-container page-main__fill ua-bg-supporting-one-opacity-ten ua-padding-jumbo-vertical">
      <div className="ua-grid ua-grid-gap-2-sm ua-grid-gap-3-lg ua-grid-cols-12">
        <div className="auth-content ua-col-span-3-8-lg ua-col-span-2-10-md ua-col-span-1-12-sm">
          <H1 className="ua-text-center" headingStyle={2}>
            {ROUTES.register.title}
          </H1>
          <Paragraph bodyStyle={1} className="ua-text-center">
            You’ll need to enter your Agency’s{" "}
            <span className="ua-text-nowrap">United Advantage ID</span>
            <span className="ua-text-newline-md">
              to begin the quick, 60 second process.
            </span>
          </Paragraph>
          <div className="auth-content__inner tds-padding-xxlg-top">
            <BeginRegistrationForm />
            <footer className="ua-text-center">
              <Paragraph>
                <TempoRouterLink
                  className="tds-margin-xlg-horizontal"
                  component={Link}
                  to={ROUTES.requestAgencyId.path}
                >
                  Request Agency ID
                </TempoRouterLink>
                <TempoRouterLink
                  className="tds-margin-xlg-horizontal"
                  component={Link}
                  to={ROUTES.login.path}
                >
                  Back to login page
                </TempoRouterLink>
              </Paragraph>
            </footer>
          </div>
        </div>
      </div>
    </section>
  );
}
